import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6cfedd73")
const _hoisted_1 = { class: "login_page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "login_image" }, null, -1)
const _hoisted_3 = { class: "login_form" }
const _hoisted_4 = { class: "p-mb-3" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "p-text-center"
}
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-times-circle p-mb-4",
  style: {"font-size":"4rem"}
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "success"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-check-circle p-mb-4",
  style: {"font-size":"4rem"}
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Email successfully validated")
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("img", {
          alt: "Logo",
          src: '/assets/layout/images/' + _ctx.logo,
          width: "400"
        }, null, 8, _hoisted_5)
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : (_openBlock(), _createElementBlock("h3", _hoisted_7, [
            (!_ctx.response.valid)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createTextVNode(_toDisplayString(_ctx.response.message), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, _hoisted_15))
          ]))
    ])
  ]))
}